(() => {
  if (window.wrQtyInit) return;
  window.wrQtyInit = true;

  const clamp = (value, min, max) => {
    let next = isNaN(value) ? min : value;
    next = Math.max(min, next);
    if (max !== Infinity) next = Math.min(max, next);
    return next;
  };

  const parseBounds = (input) => {
    const min = input.min ? parseFloat(input.min) : 1;
    const max = input.max ? parseFloat(input.max) : Infinity;
    const step = parseFloat(input.step) || 1;
    return { min, max, step };
  };

  const syncButtons = (input, stepper) => {
    const { min, max } = parseBounds(input);
    const val = parseFloat(input.value);
    const down = stepper.querySelector('[data-wr-qty-btn="down"]');
    const up = stepper.querySelector('[data-wr-qty-btn="up"]');

    if (down) down.disabled = val <= min;
    if (up) up.disabled = max !== Infinity && val >= max;
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-wr-qty-btn]');
    if (!btn) return;

    const stepper = btn.closest('.wr-qty-stepper');
    if (!stepper) return;

    const input = stepper.querySelector('.wr-qty-input');
    if (!input) return;

    const dir = btn.dataset.wrQtyBtn;
    const { min, max, step } = parseBounds(input);
    const current = parseFloat(input.value);

    const next = clamp(dir === 'down' ? current - step : current + step, min, max);
    input.value = next;
    syncButtons(input, stepper);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('input', (event) => {
    const input = event.target.closest('.wr-qty-input');
    if (!input) return;
    const stepper = input.closest('.wr-qty-stepper');
    if (!stepper) return;
    if (input.value.trim() === '') return;

    const { min, max } = parseBounds(input);
    const current = parseFloat(input.value);
    const next = clamp(current, min, max);
    if (next !== current) input.value = next;
    syncButtons(input, stepper);
  });

  document.addEventListener('focusin', (event) => {
    const input = event.target.closest('.wr-qty-input');
    if (!input) return;
    input.value = '';
  });

  document.addEventListener('blur', (event) => {
    const input = event.target.closest('.wr-qty-input');
    if (!input) return;
    const stepper = input.closest('.wr-qty-stepper');
    if (!stepper) return;

    if (input.value.trim() !== '') return;
    const { min } = parseBounds(input);
    input.value = min;
    syncButtons(input, stepper);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  const init = () => {
    document.querySelectorAll('.wr-qty-stepper .wr-qty-input').forEach((input) => {
      const stepper = input.closest('.wr-qty-stepper');
      if (!stepper) return;
      syncButtons(input, stepper);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
